import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';
import { CoordinatePatient } from '~/types/coordinate';
import CoordinatePatientRow from './CoordinatePatientRow';

interface Props {
  patients: CoordinatePatient[];
}

const CoordinatePatientTable: React.FC<Props> = ({ patients }) => {
  if (patients.length === 0) {
    return (
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">No patients match the current filters.</Typography>
      </Paper>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 600 }}>Patient</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Disposition</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Location</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Expected Discharge</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Insurance</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Urgency</TableCell>
            <TableCell align="center" sx={{ fontWeight: 600 }}>Assigned</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {patients.map(patient => (
            <CoordinatePatientRow key={patient.id} patient={patient} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CoordinatePatientTable;
